import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

/**
 * Fast "powered by"-badge i nederste højre hjørne.
 * Vises kun på forsiden, login og modul-oversigten — IKKE på kortet
 * eller inde i de enkelte moduler (ville forstyrre setuppet).
 * Respekterer platform-indstillingen powered_by_enabled (kan slås til/fra).
 */
let cachedSettings = null;

const SHOW_ON_PATHS = ["/", "/login", "/profil"];

export default function PoweredByBadge() {
  const location = useLocation();
  const [settings, setSettings] = useState(cachedSettings);

  useEffect(() => {
    if (cachedSettings) return;
    axios.get(`${API}/platform/settings`)
      .then(r => { cachedSettings = r.data; setSettings(r.data); })
      .catch(() => {});
  }, []);

  if (!settings?.powered_by_enabled) return null;
  if (!SHOW_ON_PATHS.includes(location.pathname)) return null;

  return (
    <div
      data-testid="powered-by-badge"
      className="fixed bottom-1 right-2 z-[900] pointer-events-none select-none"
    >
      <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/40 backdrop-blur-sm text-[11px] text-white/70 shadow-sm">
        <span className="font-semibold text-white/90">{settings.platform_name || 'Resovia'}</span>
        &mdash; {settings.powered_by_text || 'powered by'}{' '}
        <span className="font-semibold text-white/90">{settings.host_name}</span>
      </span>
    </div>
  );
}
